'use client';
import { styled } from '@mui/material/styles';
import MuiRadio, { RadioProps } from '@mui/material/Radio';

const StyledRadio = styled(MuiRadio)<RadioProps>({});

export const Radio = (props: RadioProps) => <StyledRadio {...props} />;
